module.exports = __webpack_public_path__ + "static/media/82.8a257c7d.jpg";